import cytoscape from 'cytoscape'
import cytoscapeNavigator from 'cytoscape-navigator'

// Register the navigator extension with Cytoscape
cytoscape.use(cytoscapeNavigator)

/**
 * Navigator API interface returned by the navigator extension
 */
export interface NavigatorApi {
  destroy: () => void
}

/**
 * Sets up the navigator (minimap) for a Cytoscape instance.
 *
 * @param cy - The Cytoscape instance
 * @param params - The navigator configuration parameters
 * @param params.container - The HTML element that will contain the minimap
 * @returns The navigator instance for cleanup
 */
export function setupNavigator(
  cy: cytoscape.Core,
  { container }: setupNavigator.AdditionalParams,
): NavigatorApi {
  // The types expect string | boolean, but the library accepts HTMLElement
  // We need to pass an ID selector, so we'll set an ID on the container
  const containerId = `cytoscape-navigator-${Date.now()}`
  container.id = containerId

  const nav = cy.navigator({
    container: `#${containerId}`,
    dblClickDelay: 200,
    rerenderDelay: 100,
    viewLiveFramerate: 60,
  })
  return nav
}
export namespace setupNavigator {
  export interface AdditionalParams {
    readonly container: HTMLElement
  }
}

/**
 * Destroys a navigator instance.
 *
 * @param nav - The navigator instance to destroy
 */
export function destroyNavigator(nav: NavigatorApi): void {
  nav.destroy()
}
